import { Button } from "@material-ui/core"
import { useIsDesktop } from "common/MediaQueries"
import { useQuickPurchaseContext } from "components/QuickPurchasePage/QuickPurchaseContext"
import dynamic from "next/dynamic"
import Link from "next/link"
import { useRef } from "react"
import styled from "styled-components"
import confettiCard from "../../../public/confetti-card-lottie.json"

const StyledCardWrapper = styled.div`
  display: flex;
  justify-content: center;
  overflow: hidden;
  padding: 16px;
`

const StyledCardInner = styled.div`
  position: relative;
  width: 329px;
  height: 180px;
  padding: 16px;
  border-radius: 16px;
  box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.12);

  background: url(/big-m.svg);
  background-position: -22px 100%;
  background-repeat: no-repeat, no-repeat;
  background-size: 134px 121px;

  overflow: hidden;

  ${(p) => p.theme.breakpoints.up("md")} {
    width: 492px;
    height: 270px;

    background-position: -34px 100%;
    background-repeat: no-repeat, no-repeat;
    background-size: 221px 200px;
  }

  ${(p) => p.theme.breakpoints.up("xl")} {
    width: 602px;
    height: 330px;

    background-position: -34px 100%;
    background-repeat: no-repeat, no-repeat;
    background-size: 221px 200px;
  }
`

const Lottie = dynamic(() => import("lottie-react"), { ssr: false })

const StyledLottie = styled(Lottie)<{
  $isDesktop: boolean
}>`
  position: absolute;
  left: 16px;
  height: ${(p) => (p?.$isDesktop ? "450px" : "311px")};
  width: 100%;
`

const StyledCardTitle = styled.h2`
  margin: 0;
  color: var(--Black, #000);
  text-align: right;
`

const StyledCardTitleHebrew = styled.span`
  text-align: right;
  font-family: NarkisBlock;
  font-size: 32px;
  font-style: normal;
  font-weight: bold;
  line-height: normal;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 40px;
  }
`

const StyledCardTitleEnglish = styled.span`
  font-family: Speedee;
  font-size: 28px;
  font-style: normal;
  font-weight: bold;
  line-height: normal;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 38px;
  }
`

const StyledStartProcessButton = styled(Button)`
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  background: var(--White, #fff);
  padding: 8px;
  margin-top: 52px;
  display: flex;
  justify-content: flex-start;

  &:hover {
    background: none;
    border-color: var(--Grey, #757575);
  }

  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: 121px;
  }
`

const StartButtonInner = styled.div`
  display: flex;
  gap: 40px;
`

const StyledButtonText = styled.div`
  display: flex;
  flex-direction: column;
`

const BaseText = styled.p`
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: NarkisBlock;
  text-align: right;
  margin: 0;
`

const StyledButtonHelpText = styled(BaseText)`
  color: var(--Dark-Grey, #2d2d2d);
  font-size: 14px;
`

const StyledButtonAmount = styled(BaseText)`
  color: var(--Black, #000);
  font-size: 18px;
`

const StyledArrowContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 40px;
  height: 40px;
  padding: 8px;
  border-radius: 8px;

  background: var(--Yellow, #ffbc0d);

  &:hover img {
    transform: translateX(-4px);
    transition: transform 800ms cubic-bezier(0.3, -0.05, 0.7, -0.5);
  }
`

const StyledArrow = styled.img`
  width: 8px;
  height: 14px;
  position: relative;
  left: 4px;

  stroke-width: 2px;
  stroke: var(--Primary-Black, #000);

  transition: transform 800ms cubic-bezier(0.3, -0.05, 0.7, -0.5);
`

type MainCardProps = {
  defaultPrice: number
}

const MainCard = ({ defaultPrice }: MainCardProps) => {
  const ref = useRef(null)
  const isDesktop = useIsDesktop()
  const { setGiftCardPrice } = useQuickPurchaseContext()

  return (
    <StyledCardWrapper>
      <StyledCardInner>
        <StyledLottie
          loop={false}
          lottieRef={ref}
          animationData={confettiCard}
          $isDesktop={isDesktop}
        />
        <StyledCardTitle>
          <StyledCardTitleHebrew>מקדונלד&apos;ס </StyledCardTitleHebrew>
          <StyledCardTitleEnglish>GiftCard</StyledCardTitleEnglish>
        </StyledCardTitle>
        <Link href="/quick-purchase">
          <StyledStartProcessButton
            onClick={() => setGiftCardPrice(defaultPrice || 100)}
          >
            <StartButtonInner>
              <StyledButtonText>
                <StyledButtonHelpText>הזנת סכום</StyledButtonHelpText>
                <StyledButtonAmount>
                  ₪{defaultPrice || "100"}
                </StyledButtonAmount>
              </StyledButtonText>
              <StyledArrowContainer>
                <StyledArrow src="/left-arrow.svg" />
              </StyledArrowContainer>
            </StartButtonInner>
          </StyledStartProcessButton>
        </Link>
      </StyledCardInner>
    </StyledCardWrapper>
  )
}

export default MainCard
